import { useEffect } from 'react';

/**
 * Meta Pixel — Movement Group Ready.
 * The single place the pixel is initialised. Only this pixel id is used and
 * PageView is tracked exactly once per page load (guarded against React
 * StrictMode double effects, re-mounts and any pre-existing fbq instance).
 * TODO: confirm this is the pixel for this product's ad account.
 */
const PIXEL_ID = '1461581986119531';
type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: Fbq;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
    __mgrPixelPageViewSent?: boolean;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.__mgrPixelPageViewSent) return;
    window.__mgrPixelPageViewSent = true;
    if (!window.fbq) {
      const fbq = function (...args: unknown[]) {
        if (fbq.callMethod) fbq.callMethod(...args);else fbq.queue.push(args);
      } as Fbq;
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      window.fbq = fbq;
      if (!window._fbq) window._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return null;
}